var Point =
/** @class */
function () {
  function Point(x, y) {
    if (x === void 0) {
      x = 0;
    }

    if (y === void 0) {
      y = 0;
    }

    this.x = 0;
    this.y = 0;
    this.x = x;
    this.y = y;
  }

  Point.prototype.clone = function () {
    return new Point(this.x, this.y);
  };

  Point.prototype.copyFrom = function (p) {
    this.x = p.x;
    this.y = p.y;
  };

  return Point;
}();

export { Point };